/**
 * Associates ChowNow user.id to LaunchDarkly identity.
 *
 * @public
 * @param {Object} user The initial Dashboard user object. We only need id and is_chownow_admin.
 * @param {Object} props Props from ProtectedLayout so we can access ldClient from LaunchDarkly.
 * @returns  Nothing. This is a void function that only performs a task.
 */

// Associates ChowNow user_id to LaunchDarkly identity
export function initLaunchDarklyUser(
  {
    id,
    group_id: groupId,
    is_chownow_admin: isChownowAdmin,
    company_id: companyId,
    email,
    currentRestaurant,
    currentCompany,
  },
  ldClient,
) {
  const key = isChownowAdmin ? `internal-user-${id}` : `rp-user-${id}`;
  const company = isChownowAdmin ? currentCompany : companyId;
  const privateAttributes = ['email'];
  const chowNowUser = {
    currentRestaurant,
    key,
    kind: 'user',
    group: groupId,
    user: id,
    company,
    email,
    _meta: {
      privateAttributes,
    },
  };

  if (ldClient) {
    // Limit PII sent to LD so we don't need to worry about it for CCPA
    ldClient.identify(chowNowUser, { privateAttributes });
  }
}

export function initLaunchDarklyCubohUser(
  { cubohUser, currentRestaurant, currentCompany, isImpersonating },
  ldClient,
) {
  if (!cubohUser) return;
  const {
    id,
    username,
  } = cubohUser;

  const cubohLdUser = {
    key: `cuboh-user-${id}`,
    kind: 'user',
    user: id,
    username,
    currentRestaurant,
    cubohCompany: cubohUser.company,
    company: currentCompany,
    isImpersonating: !!isImpersonating,
  };

  if (ldClient) {
    // Limit PII sent to LD so we don't need to worry about it for CCPA
    ldClient.identify(cubohLdUser);
  }
}
